var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('top-navigation',{key:this.$user.authenticated,on:{"logout-request":_vm.logout}}),_vm._v(" "),_c('div',{attrs:{"id":"router-view-container"}},[_c('router-view')],1),_vm._v(" "),_c('global-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }